/* eslint-disable consistent-return */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable prefer-const */
/* eslint-disable no-use-before-define */
/* eslint-disable no-irregular-whitespace */
/* eslint-disable no-plusplus */
/* eslint-disable no-param-reassign */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { FormattedMessage, useIntl } from 'react-intl';
import {
  MdOutlineFilterAlt,
  MdOutlineWhatsapp,
  MdOutlineMail,
  MdOutlineSupportAgent,
  MdPhone,
  MdEmail,
  MdOutlineCreate,
  MdClose,
  MdOutlineArrowBack,
} from 'react-icons/md';
import { IoMdEye, IoMdEyeOff } from 'react-icons/io';
import { BsGraphUpArrow } from 'react-icons/bs';
import ProgressBar from 'react-bootstrap/ProgressBar';
import { Row, Col } from 'react-bootstrap';
import add from 'date-fns/add';
import sub from 'date-fns/sub';
import {
  searchFlightsApi,
  validateInternationalFlightPriceApi,
  emailFlightOptions,
  getPassThroughInfo,
  getFareInclusion,
  getFareInclusionINTL,
} from '../../api/flightApi';
import AppLoading from '../../shared/components/app-loading/AppLoading';
import SortOptions from '../one-way/SortOptions';
import {
  getGroupedFlightOptions,
  isSameDate,
  isBeforeDate,
  formatDate,
  formatCurrency,
  getInternationalGroupedFlights,
  hideUpdatesOptions,
  showUpdatesOptions,
  isEmpty,
  getNewDate,
  hideHeaderFooterInMobile,
  showHeaderFooterInMobile,
  isMobileWidth,
} from '../../shared/helper-utils/appUtils';
import ModifySearch from '../flights/ModifySearch';
import AppIconButton from '../../shared/components/app-icon-button/AppIconButton';
import AppSidebar from '../../shared/components/app-sidebar/AppSidebar';
import RoundTripFilters from '../round-trip/RoundTripFilters';
import ResultsFooter from '../one-way/ResultsFooter';
import {
  getObjectFromLS,
  getUserAgentId,
  getValueFromAppConfig,
} from '../../shared/helper-utils/localStorage';
import {
  NAVIGATION_ROUTES,
  API_DATE_FORMAT,
  DATE_MONTH_YEAR_VIEW_FORMAT,
  ONLY_DATE_MONTH_FORMAT,
  TODAY_DATE,
} from '../../shared/constants/Constants';
import AppModal from '../../shared/components/app-modal/AppModal';
import NoSearchResults from '../one-way/NoSearchResults';
import CountdownTimer from '../../shared/components/countdown-timer/CountdownTimer';
import AppAlert from '../../shared/components/app-alert/AppAlert';
import RoundTripIntlResultCard from './RoundTripIntlResultCard';
import RoundTripIntlEmailContent from './RoundTripIntlEmailContent';
import AppButton from '../../shared/components/app-button/AppButton';
import { debounce } from '../../api/apiUtils';
import RoundTripIntlWhatsAppModal from './RoundTripIntlWhatsAppModal';
import { getUserDetails } from '../../api/profileApi';
import AppPreviewLoader from '../../shared/components/app-preview-loader/AppPreviewLoader';
import AppSelect from '../../shared/components/app-select/AppSelect';
import { APP_USER_PROFILE } from '../../saas/AppStorageStaticNames';

const SEARCH_AIRLINES = ['All', 'GWS'];
const CORPORATE_SEARCH_AIRLINES = ['All'];
const BRANDED_AIRLINES = ['All'];
const SERIES_AIRLINES = ['All'];

function FlightRoundTripIntlSearchResultsPage() {
  const intl = useIntl();
  const formattedMessage = (message) => {
    return intl.formatMessage({ id: message });
  };
  const FIFTEEN_MIN_IN_MILLI_SECS = 11 * 60 * 1000;
  const NOW_IN_MILLI_SECS = getNewDate(TODAY_DATE).getTime();
  const [fifteenMinFromNowInMilli, setFifteenMinFromNowInMilli] = useState(
    NOW_IN_MILLI_SECS + FIFTEEN_MIN_IN_MILLI_SECS,
  );
  const navigate = useNavigate();
  const [alert, setAlert] = useState(undefined);
  const [searchParams] = useSearchParams();
  const bookingResponseRef = useRef(null);
  const allSearchResultsRef = useRef([]);
  const [hasSearchResults, setHasSearchResults] = useState(undefined);
  const [isLoading, setIsLoading] = useState(false);
  const [searchResults, setSearchResults] = useState([]);
  const [searchRequest, setSearchRequest] = useState(undefined);
  const [openFilters, setOpenFilters] = useState(false);
  const [minFlightFare, setMinFlightFare] = useState(0);
  const [maxFlightFare, setMaxFlightFare] = useState(0);
  const [selectedFilters, setSelectedFilters] = useState({
    selectedMinPrice: 0,
    selectedMaxPrice: 0,
    selectedOnwardStops: [],
    selectedReturnStops: [],
    selectedOnwardDepartureTimes: [],
    selectedReturnDepartureTimes: [],
    selectedOnwardArraivalTimes: [],
    selectedReturnArraivalTimes: [],
    selectedOnwardCarriers: [],
    selectedReturnCarriers: [],
    selectedFareTypes: [],
    selectedRefundStatus: [],
    selectedFlightNumber: '',
    selectedEquipment: '',
    isOnwardSameDayArraival: false,
    isReturnSameDayArraival: false,
  });
  const selectedOnwardFareRef = useRef(undefined);
  const selectedOnwardFlightRef = useRef(undefined);
  const selectedReturnFlightRef = useRef(undefined);
  const [isAmPmFormatSelected, setIsAmPmFormatSelected] = useState(false);
  const [showPriceChangedModal, setShowPriceChangedModal] = useState(false);
  const [progressWidth, setProgressWidth] = useState(0);
  const showProgressRef = useRef(true);
  const flightCarriesRef = useRef([]);
  const flightFaresRef = useRef([]);
  const agentid = getUserAgentId();
  const [showInvoiceFare, setShowInvoiceFare] = useState(false);
  const [openWhatsappModal, setOpenWhatsappModal] = useState(false);
  const [openEmailModal, setOpenEmailModal] = useState(false);
  const [shownResults, setShownResults] = useState([]);
  const [page, setPage] = useState(0);
  const sortOrderRef = useRef('asc');
  const sortParamRef = useRef('price');
  const fareInclusionRef = useRef([]);
  const [abortController, setAbortController] = useState(new AbortController());
  const [oldAmount, setOldAmount] = useState(0);
  const [newRepricedAmount, setnewRepricedAmount] = useState(0);
  const [selectedForEmail, setSelectedForEmail] = useState([]);
  const passThroughResponseRef = useRef(null);
  const [showSupportDetails, setShowSupportDetails] = useState(false);
  const [OpenAlerDialog, setOpenAlerDialog] = useState(false);
  const alertMessageRef = useRef('');
  const flightModifyRef = useRef(null);
  const [flightModifyDivHeight, setFlightModifyDivHeight] = useState(0);
  const [isModifySearch, setIsModifySearch] = useState(false);
  const sectorInfoRef = useRef('');

  useEffect(() => {
    hideHeaderFooterInMobile();
    return () => showHeaderFooterInMobile();
  }, []);

  useEffect(() => {
    const resizeObserver = new ResizeObserver((entries) => {
      // eslint-disable-next-line no-restricted-syntax
      for (const entry of entries) {
        if (entry.target === flightModifyRef.current) {
          setFlightModifyDivHeight(entry.contentRect.height);
        }
      }
    });

    if (flightModifyRef.current) {
      resizeObserver.observe(flightModifyRef.current);
    }

    return () => {
      if (flightModifyRef.current) {
        resizeObserver.unobserve(flightModifyRef.current);
      }
    };
  }, [searchRequest]);

  useEffect(() => {
    hideUpdatesOptions();
    return () => showUpdatesOptions();
  });

  const appendResults = (pageNumber, results) => {
    const startindex = pageNumber * 20;
    const endIndex = startindex + 20;
    let newResults;
    if (startindex > results.length) {
      return;
    }
    if (endIndex > results.length) {
      newResults = results.slice(0, results.length);
    } else {
      newResults = results.slice(0, endIndex);
    }
    setShownResults(newResults);
  };

  useEffect(() => {
    appendResults(page, searchResults);
  }, [page]);

  useEffect(() => {
    const handleScroll = () => {
      const { scrollY } = window;
      const pageHeight =
        document.documentElement.scrollHeight - window.innerHeight - 100;
      // const scrollThreshold = 100;
      if (scrollY >= pageHeight) {
        setPage((prev) => prev + 1);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const handleSort = (param, order, results) => {
    sortOrderRef.current = order;
    sortParamRef.current = param;
    let list;
    if (results === undefined) {
      list = [...searchResults];
    } else {
      list = results;
    }
    if (param === 'price') {
      if (order === 'desc') {
        list.sort(
          (flightOption1, flightOption2) =>
            flightOption2.recommendedflight[0].flightfare[0].totalfq -
            flightOption1.recommendedflight[0].flightfare[0].totalfq,
        );
      } else {
        list.sort(
          (flightOption1, flightOption2) =>
            flightOption1.recommendedflight[0].flightfare[0].totalfq -
            flightOption2.recommendedflight[0].flightfare[0].totalfq,
        );
      }
    } else if (param === 'duration') {
      if (order === 'desc') {
        list.sort(
          (flightOption1, flightOption2) =>
            flightOption2.recommendedflight[0].totaljourneyduration +
            flightOption2.recommendedflight[1].totaljourneyduration -
            flightOption1.recommendedflight[0].totaljourneyduration -
            flightOption1.recommendedflight[1].totaljourneyduration,
        );
      } else {
        list.sort(
          (flightOption1, flightOption2) =>
            flightOption1.recommendedflight[0].totaljourneyduration +
            flightOption1.recommendedflight[1].totaljourneyduration -
            flightOption2.recommendedflight[0].totaljourneyduration -
            flightOption2.recommendedflight[1].totaljourneyduration,
        );
      }
    } else if (param === 'departure') {
      if (order === 'desc') {
        list.sort(
          (flightOption1, flightOption2) =>
            parseInt(
              flightOption2.recommendedflight[0].flightlegs[0].deptime,
              10,
            ) -
            parseInt(
              flightOption1.recommendedflight[0].flightlegs[0].deptime,
              10,
            ),
        );
      } else {
        list.sort(
          (flightOption1, flightOption2) =>
            parseInt(
              flightOption1.recommendedflight[0].flightlegs[0].deptime,
              10,
            ) -
            parseInt(
              flightOption2.recommendedflight[0].flightlegs[0].deptime,
              10,
            ),
        );
      }
    } else if (param === 'arrival') {
      if (order === 'desc') {
        list.sort(
          (flightOption1, flightOption2) =>
            parseInt(
              flightOption2.recommendedflight[0].flightlegs[0].arrtime,
              10,
            ) -
            parseInt(
              flightOption1.recommendedflight[0].flightlegs[0].arrtime,
              10,
            ),
        );
      } else {
        list.sort(
          (flightOption1, flightOption2) =>
            parseInt(
              flightOption1.recommendedflight[0].flightlegs[0].arrtime,
              10,
            ) -
            parseInt(
              flightOption2.recommendedflight[0].flightlegs[0].arrtime,
              10,
            ),
        );
      }
    } else if (param === 'airline') {
      if (order === 'desc') {
        list.sort((flightOption1, flightOption2) =>
          flightOption2.recommendedflight[0].flightlegs[0].validatingcarriername.localeCompare(
            flightOption1.recommendedflight[0].flightlegs[0]
              .validatingcarriername,
          ),
        );
      } else {
        list.sort((flightOption1, flightOption2) =>
          flightOption1.recommendedflight[0].flightlegs[0].validatingcarriername.localeCompare(
            flightOption2.recommendedflight[0].flightlegs[0]
              .validatingcarriername,
          ),
        );
      }
    }
    setPage(0);
    appendResults(0, list);
    setSearchResults(list);
  };

  const handleSort1 = (param, order, results) => {
    sortOrderRef.current = order;
    sortParamRef.current = param;
    let list;
    if (results === undefined) {
      list = [...searchResults];
    } else {
      list = results;
    }
    if (param === 'price') {
      if (order === 'desc') {
        list.sort(
          (flightOption1, flightOption2) =>
            flightOption2.recommendedflight[0].flightfare[0].totalfq -
            flightOption1.recommendedflight[0].flightfare[0].totalfq,
        );
      } else {
        list.sort(
          (flightOption1, flightOption2) =>
            flightOption1.recommendedflight[0].flightfare[0].totalfq -
            flightOption2.recommendedflight[0].flightfare[0].totalfq,
        );
      }
    } else if (param === 'duration') {
      if (order === 'desc') {
        list.sort(
          (flightOption1, flightOption2) =>
            flightOption2.recommendedflight[0].totaljourneyduration +
            flightOption2.recommendedflight[1].totaljourneyduration -
            flightOption1.recommendedflight[0].totaljourneyduration -
            flightOption1.recommendedflight[1].totaljourneyduration,
        );
      } else {
        list.sort(
          (flightOption1, flightOption2) =>
            flightOption1.recommendedflight[0].totaljourneyduration +
            flightOption1.recommendedflight[1].totaljourneyduration -
            flightOption2.recommendedflight[0].totaljourneyduration -
            flightOption2.recommendedflight[1].totaljourneyduration,
        );
      }
    } else if (param === 'departure') {
      if (order === 'desc') {
        list.sort(
          (flightOption1, flightOption2) =>
            parseInt(
              flightOption2.recommendedflight[0].flightlegs[0].deptime,
              10,
            ) -
            parseInt(
              flightOption1.recommendedflight[0].flightlegs[0].deptime,
              10,
            ),
        );
      } else {
        list.sort(
          (flightOption1, flightOption2) =>
            parseInt(
              flightOption1.recommendedflight[0].flightlegs[0].deptime,
              10,
            ) -
            parseInt(
              flightOption2.recommendedflight[0].flightlegs[0].deptime,
              10,
            ),
        );
      }
    } else if (param === 'arrival') {
      if (order === 'desc') {
        list.sort(
          (flightOption1, flightOption2) =>
            parseInt(
              flightOption2.recommendedflight[0].flightlegs[0].arrtime,
              10,
            ) -
            parseInt(
              flightOption1.recommendedflight[0].flightlegs[0].arrtime,
              10,
            ),
        );
      } else {
        list.sort(
          (flightOption1, flightOption2) =>
            parseInt(
              flightOption1.recommendedflight[0].flightlegs[0].arrtime,
              10,
            ) -
            parseInt(
              flightOption2.recommendedflight[0].flightlegs[0].arrtime,
              10,
            ),
        );
      }
    } else if (param === 'airline') {
      if (order === 'desc') {
        list.sort((flightOption1, flightOption2) =>
          flightOption2.recommendedflight[0].flightlegs[0].validatingcarriername.localeCompare(
            flightOption1.recommendedflight[0].flightlegs[0]
              .validatingcarriername,
          ),
        );
      } else {
        list.sort((flightOption1, flightOption2) =>
          flightOption1.recommendedflight[0].flightlegs[0].validatingcarriername.localeCompare(
            flightOption2.recommendedflight[0].flightlegs[0]
              .validatingcarriername,
          ),
        );
      }
    }
    setPage(0);
    appendResults(0, list);
    return list;
  };

  const handleApplyFilter = debounce((filters) => {
    setSelectedFilters(filters);
    let filteredSearchResults = JSON.parse(
      JSON.stringify(allSearchResultsRef.current),
    );
    if (filters.selectedOnwardStops.length > 0) {
      filteredSearchResults = filteredSearchResults.filter(
        (resultRow) =>
          filters.selectedOnwardStops.indexOf(
            (resultRow.recommendedflight[0].flightlegs.length - 1).toString(),
          ) > -1,
      );
    }
    if (filters.selectedReturnStops.length > 0) {
      filteredSearchResults = filteredSearchResults.filter(
        (resultRow) =>
          filters.selectedReturnStops.indexOf(
            (resultRow.recommendedflight[1].flightlegs.length - 1).toString(),
          ) > -1,
      );
    }
    if (filters.selectedOnwardCarriers.length > 0) {
      filteredSearchResults = filteredSearchResults.filter((resultRow) => {
        let legs = resultRow.recommendedflight[0].flightlegs;
        legs = Array.isArray(legs) ? legs : [legs];
        return legs.some(
          (x) =>
            filters.selectedOnwardCarriers.indexOf(x.validatingcarriername) >
            -1,
        );
      });
    }
    if (filters.selectedReturnCarriers.length > 0) {
      filteredSearchResults = filteredSearchResults.filter((resultRow) => {
        let legs = resultRow.recommendedflight[1].flightlegs;
        legs = Array.isArray(legs) ? legs : [legs];
        return legs.some(
          (x) =>
            filters.selectedReturnCarriers.indexOf(x.validatingcarriername) >
            -1,
        );
      });
    }
    if (filters.selectedRefundStatus.length > 0) {
      filteredSearchResults.forEach((resultRow) => {
        let fares = resultRow.recommendedflight[0].flightfare;
        fares = Array.isArray(fares) ? fares : [fares];
        const filteredFares = fares.filter(
          (x) => filters.selectedRefundStatus.indexOf(x.refundableinfo) > -1,
        );
        resultRow.recommendedflight[0].flightfare = filteredFares;
      });
      filteredSearchResults = filteredSearchResults.filter((resultRow) => {
        const fares = resultRow.recommendedflight[0].flightfare;
        return fares.length > 0;
      });
    }
    if (filters.selectedFareTypes.length > 0) {
      filteredSearchResults.forEach((resultRow) => {
        let fares = resultRow.recommendedflight[0].flightfare;
        fares = Array.isArray(fares) ? fares : [fares];
        const filteredFares = fares.filter(
          (x) => filters.selectedFareTypes.indexOf(x.faretype) > -1,
        );
        resultRow.recommendedflight[0].flightfare = filteredFares;
      });
      filteredSearchResults = filteredSearchResults.filter((resultRow) => {
        const fares = resultRow.recommendedflight[0].flightfare;
        return fares.length > 0;
      });
    }
    if (filters.selectedOnwardDepartureTimes.length > 0) {
      filteredSearchResults = filteredSearchResults.filter((resultRow) => {
        const depTime = Number(
          resultRow.recommendedflight[0].flightlegs[0].deptime,
        );
        return filters.selectedOnwardDepartureTimes.some((timeRange) => {
          const timeRangeArr = timeRange.split('-');
          return (
            depTime >= Number(timeRangeArr[0]) &&
            depTime <= Number(timeRangeArr[1])
          );
        });
      });
    }
    if (filters.selectedReturnDepartureTimes.length > 0) {
      filteredSearchResults = filteredSearchResults.filter((resultRow) => {
        const depTime = Number(
          resultRow.recommendedflight[1].flightlegs[0].deptime,
        );
        return filters.selectedReturnDepartureTimes.some((timeRange) => {
          const timeRangeArr = timeRange.split('-');
          return (
            depTime >= Number(timeRangeArr[0]) &&
            depTime <= Number(timeRangeArr[1])
          );
        });
      });
    }
    if (filters.selectedOnwardArraivalTimes.length > 0) {
      filteredSearchResults = filteredSearchResults.filter((resultRow) => {
        const depTime = Number(
          resultRow.recommendedflight[0].flightlegs[
            resultRow.recommendedflight[0].flightlegs.length - 1
          ].arrtime,
        );
        return filters.selectedOnwardArraivalTimes.some((timeRange) => {
          const timeRangeArr = timeRange.split('-');
          return (
            depTime >= Number(timeRangeArr[0]) &&
            depTime <= Number(timeRangeArr[1])
          );
        });
      });
    }
    if (filters.selectedReturnArraivalTimes.length > 0) {
      filteredSearchResults = filteredSearchResults.filter((resultRow) => {
        const depTime = Number(
          resultRow.recommendedflight[1].flightlegs[
            resultRow.recommendedflight[1].flightlegs.length - 1
          ].arrtime,
        );
        return filters.selectedReturnArraivalTimes.some((timeRange) => {
          const timeRangeArr = timeRange.split('-');
          return (
            depTime >= Number(timeRangeArr[0]) &&
            depTime <= Number(timeRangeArr[1])
          );
        });
      });
    }
    if (filters.selectedMinPrice) {
      filteredSearchResults = filteredSearchResults.filter(
        (resultRow) =>
          resultRow.recommendedflight[0].flightfare[0].totalfq >=
          filters.selectedMinPrice,
      );
    }
    if (filters.selectedMaxPrice) {
      filteredSearchResults = filteredSearchResults.filter(
        (resultRow) =>
          resultRow.recommendedflight[0].flightfare[0].totalfq <=
          filters.selectedMaxPrice,
      );
    }
    if (filters.selectedFlightNumber !== '') {
      filteredSearchResults = filteredSearchResults.filter((resultRow) => {
        const carrier = filters.selectedFlightNumber
          .toLowerCase()
          .split('-')[0]
          .substring(0, 2);
        const fltNum = filters.selectedFlightNumber.split('-')[1];
        const onwardLegs = resultRow.recommendedflight[0].flightlegs;
        const returnLegs = resultRow.recommendedflight[1].flightlegs;
        const legs = [...onwardLegs, ...returnLegs];

        if (fltNum) {
          return legs.some(
            (x) =>
              x.carrier.toLowerCase().indexOf(carrier) > -1 &&
              x.flightnumber.indexOf(fltNum) > -1,
          );
        }
        return legs.some((x) => x.carrier.toLowerCase().indexOf(carrier) > -1);
      });
    }
    if (filters.selectedEquipment !== '') {
      filteredSearchResults = filteredSearchResults.filter((resultRow) => {
        let legs = resultRow.recommendedflight[0].flightlegs;
        legs = Array.isArray(legs) ? legs : [legs];
        return legs.some(
          (x) =>
            x.equipment
              .toLowerCase()
              .indexOf(filters.selectedEquipment.toLowerCase()) > -1,
        );
      });
    }
    if (filters.isOnwardSameDayArraival === true) {
      filteredSearchResults = filteredSearchResults.filter(
        (resultRow) =>
          resultRow.recommendedflight[0].flightlegs[0].depdate ===
          resultRow.recommendedflight[0].flightlegs[
            resultRow.recommendedflight[0].flightlegs.length - 1
          ].arrdate,
      );
    }
    if (filters.isReturnSameDayArraival === true) {
      filteredSearchResults = filteredSearchResults.filter(
        (resultRow) =>
          resultRow.recommendedflight[1].flightlegs[0].depdate ===
          resultRow.recommendedflight[1].flightlegs[
            resultRow.recommendedflight[1].flightlegs.length - 1
          ].arrdate,
      );
    }

    filteredSearchResults = handleSort1(
      sortParamRef.current,
      sortOrderRef.current,
      filteredSearchResults,
    );
    setSearchResults(filteredSearchResults);
  }, 300);

  const updateFlightsState = (response) => {
    if (
      response.flightjourneys &&
      Array.isArray(response.flightjourneys) &&
      response.flightjourneys.length > 0
    ) {
      const flightOptions = Array.isArray(
        response.flightjourneys[0].flightoptions,
      )
        ? response.flightjourneys[0].flightoptions
        : [response.flightjourneys[0].flightoptions];
      flightOptions?.forEach((ele) => {
        let legs = ele?.recommendedflight[0]?.flightlegs;
        legs = Array.isArray(legs) ? legs : [legs];
        ele.recommendedflight[0].numstops = legs.length - 1;
        const { validatingcarriername, validatingcarrier } = legs[0];
        if (!isEmpty(validatingcarriername) && !isEmpty(validatingcarrier)) {
          if (
            !flightCarriesRef.current.some(
              (x) => x.validatingcarriername === validatingcarriername,
            )
          ) {
            flightCarriesRef.current.push({
              validatingcarriername,
              validatingcarrier,
            });
          }
          flightCarriesRef.current.sort((option1, option2) =>
            option1.validatingcarriername.localeCompare(
              option2.validatingcarriername,
            ),
          );
        }
      });
      flightOptions?.forEach((ele) => {
        let fares = ele?.recommendedflight[0]?.flightfare;
        fares = Array.isArray(fares) ? fares : [fares];
        const { faretype } = fares[0];
        if (!isEmpty(faretype)) {
          if (
            !flightFaresRef.current.some(
              (x) => x.toLowerCase() === faretype.toLowerCase(),
            )
          ) {
            flightFaresRef.current.push(faretype);
          }
          flightFaresRef.current.sort((option1, option2) =>
            option1.localeCompare(option2),
          );
        }
      });
      flightOptions.forEach((fo) => {
        let fares = fo.recommendedflight[0].flightfare;
        fares = Array.isArray(fares) ? fares : [fares];
        fares.forEach((fare) => {
          const carrierList = [];
          const returnCarrierList = [];
          const seatsList = [];
          const returnSeatsList = [];
          const unitList = [];
          const returnUnitList = [];
          const weighlist = [];
          const returnWeightList = [];
          const bookingClassList = [];
          const returnBookingClassList = [];
          const airFreeTextList = [];
          const equipmentList = [];
          const operatedByList = [];
          const returnEquipmentList = [];
          const returnOperatedByList = [];
          fo.recommendedflight[0].flightlegs.forEach((leg) => {
            carrierList.push(leg.carrier);
            seatsList.push(leg.numseatsavailable);
            weighlist.push(leg.bagweight);
            unitList.push(leg.bagunit);
            bookingClassList.push(leg.bookingclass);
            equipmentList.push(isEmpty(leg.equipment) ? '' : leg.equipment);
            operatedByList.push(isEmpty(leg.operatedby) ? '' : leg.operatedby);
            if (leg.weather_origin !== '') {
              airFreeTextList.push(leg.weather_origin);
            }
          });
          fo.recommendedflight[1].flightlegs.forEach((leg) => {
            returnCarrierList.push(leg.carrier);
            returnUnitList.push(leg.bagunit);
            returnWeightList.push(leg.bagweight);
            returnSeatsList.push(leg.numseatsavailable);
            returnBookingClassList.push(leg.bookingclass);
            returnEquipmentList.push(
              isEmpty(leg.equipment) ? '' : leg.equipment,
            );
            returnOperatedByList.push(
              isEmpty(leg.operatedby) ? '' : leg.operatedby,
            );
          });
          let supplierName = fo.recommendedflight[0].supplier;
          if (isEmpty(supplierName)) {
            const isAmadeus = fo.recommendedflight[0].nextracustomstr
              .split(',')
              .some((word) => word.includes('AMADEUS'));
            if (isAmadeus) {
              supplierName = 'amadeus';
            }
          }
          fare.supplierName = supplierName;
          fare.nextraflightkey = fo.recommendedflight[0].nextraflightkey;
          fare.nextracustomstr = fo.recommendedflight[0].nextracustomstr;
          fare.ismorefaresavailable =
            fo.recommendedflight[0].ismorefaresavailable;
          fare.isminifarerulesrequired =
            fo.recommendedflight[0].isminifarerulesrequired;
          fare.flightCarrier = carrierList;
          fare.flightCarrierReturn = returnCarrierList;
          fare.numseatsavailable = seatsList;
          fare.flightBagWeight = weighlist;
          fare.flightBagUnit = unitList;
          fare.flightEquipment = equipmentList;
          fare.flightOperatedBy = operatedByList;
          fare.flightBagWeightReturn = returnWeightList;
          fare.flightBagUnitReturn = returnUnitList;
          fare.returnNumseatsavailable = returnSeatsList;
          fare.returnBookingClass = returnBookingClassList;
          fare.returnNumseatsavailable = returnSeatsList;
          fare.returnBookingClass = returnBookingClassList;
          fare.bookingClass = bookingClassList;
          fare.airFreeText = airFreeTextList;
        });
      });
      const allResults = [...flightOptions, ...allSearchResultsRef.current];
      let groupedFlightOptions = getInternationalGroupedFlights(allResults);
      groupedFlightOptions = Object.values(groupedFlightOptions);
      const updatedGroupedOptions = [...groupedFlightOptions];
      updatedGroupedOptions.sort(
        (flightOption1, flightOption2) =>
          flightOption1.recommendedflight[0].flightfare[0].totalfq -
          flightOption2.recommendedflight[0].flightfare[0].totalfq,
      );
      let minFare = minFlightFare;
      let maxFare = maxFlightFare;
      const totalFares = [];
      updatedGroupedOptions.forEach((option) => {
        const fares = option.recommendedflight[0].flightfare;
        totalFares.push(...fares);
      });
      totalFares.sort(
        (flightOption1, flightOption2) =>
          flightOption1.totalfq - flightOption2.totalfq,
      );
      minFare = totalFares[0].totalfq;
      maxFare = totalFares[totalFares.length - 1].totalfq;
      allSearchResultsRef.current = JSON.parse(
        JSON.stringify(updatedGroupedOptions),
      );
      setSearchResults(allSearchResultsRef.current);
      setMinFlightFare(minFare);
      setMaxFlightFare(maxFare);
      setHasSearchResults(true);
    }
  };

  const sendParallelRequests = (mergedSearchObj, controller) => {
    // setIsLoading(true);
    let current = 1;
    let normalAirlines = [];
    let corporateAirlines = [];
    let brandedAirlines = [];
    let seriesAirlines = [];
    if (mergedSearchObj.prefcarrier === 'All') {
      normalAirlines = [...SEARCH_AIRLINES];
      corporateAirlines = [...CORPORATE_SEARCH_AIRLINES];
      brandedAirlines = [...BRANDED_AIRLINES];
      seriesAirlines = [...SERIES_AIRLINES];
    } else {
      normalAirlines = [mergedSearchObj.prefcarrier];
    }
    const airlinesLength =
      normalAirlines.length +
      corporateAirlines.length +
      brandedAirlines.length +
      seriesAirlines.length;
    normalAirlines.forEach(async (airline) => {
      mergedSearchObj.prefcarrier = airline;
      mergedSearchObj.searchtype = 'normal';
      try {
        const response = await searchFlightsApi(mergedSearchObj, controller);
        if (current === airlinesLength) {
          showProgressRef.current = false;
        }
        setProgressWidth((current * 100) / airlinesLength);
        current += 1;
        updateFlightsState(response);
      } catch (error) {
        // console.error(error);
      }
    });
    if (corporateAirlines.length > 0) {
      corporateAirlines.forEach(async (airline) => {
        mergedSearchObj.prefcarrier = airline;
        mergedSearchObj.searchtype = 'corporateonly';
        try {
          const response = await searchFlightsApi(mergedSearchObj, controller);
          if (current === airlinesLength) {
            showProgressRef.current = false;
          }
          setProgressWidth((current * 100) / airlinesLength);
          current += 1;
          updateFlightsState(response);
        } catch (error) {
          // console.error(error);
        }
      });
    }
    if (brandedAirlines.length > 0) {
      brandedAirlines.forEach(async (airline) => {
        mergedSearchObj.prefcarrier = airline;
        mergedSearchObj.searchtype = 'branded';
        try {
          const response = await searchFlightsApi(mergedSearchObj, controller);
          if (current === airlinesLength) {
            showProgressRef.current = false;
          }
          setProgressWidth((current * 100) / airlinesLength);
          current += 1;
          updateFlightsState(response);
        } catch (error) {
          // console.error(error);
        }
      });
    }
    if (seriesAirlines.length > 0) {
      seriesAirlines.forEach(async (airline) => {
        mergedSearchObj.prefcarrier = airline;
        mergedSearchObj.searchtype = 'seriesfares';
        try {
          const response = await searchFlightsApi(mergedSearchObj, controller);
          if (current === airlinesLength) {
            showProgressRef.current = false;
          }
          setProgressWidth((current * 100) / airlinesLength);
          current += 1;
          updateFlightsState(response);
        } catch (error) {
          // console.error(error);
        }
      });
    }
  };

  const getFlightSearchResults = async (mergedSearchObj, controller) => {
    if (
      mergedSearchObj.searchtype === 'seniorcitizen' ||
      mergedSearchObj.searchtype === 'student'
    ) {
      if (
        parseInt(mergedSearchObj.numinfants, 10) > 0 ||
        parseInt(mergedSearchObj.numchildren, 10) > 0
      ) {
        setAlert({
          title: 'Flight Search',
          description: 'Children and Infants are not allowed for this booking',
          variant: 'error',
        });
        return false;
      }
    }
    sendParallelRequests(mergedSearchObj, controller);
  };

  const resetSearchResults = () => {
    setHasSearchResults(undefined);
    setMinFlightFare(0);
    setMaxFlightFare(0);
    setSearchResults([]);
    setProgressWidth(0);
    selectedOnwardFareRef.current = undefined;
    selectedOnwardFlightRef.current = undefined;
    selectedReturnFlightRef.current = undefined;
    allSearchResultsRef.current = [];
    showProgressRef.current = true;
    setShownResults([]);
    sortOrderRef.current = 'asc';
    sortParamRef.current = 'price';
    setPage(0);
    setSelectedForEmail([]);
    setSelectedFilters({
      selectedMinPrice: 0,
      selectedMaxPrice: 0,
      selectedOnwardStops: [],
      selectedReturnStops: [],
      selectedOnwardDepartureTimes: [],
      selectedReturnDepartureTimes: [],
      selectedOnwardArraivalTimes: [],
      selectedReturnArraivalTimes: [],
      selectedOnwardCarriers: [],
      selectedReturnCarriers: [],
      selectedFareTypes: [],
      selectedRefundStatus: [],
      selectedFlightNumber: '',
      selectedEquipment: '',
      isOnwardSameDayArraival: false,
      isReturnSameDayArraival: false,
    });
    passThroughResponseRef.current = null;
    flightCarriesRef.current = [];
    setFifteenMinFromNowInMilli(
      getNewDate(TODAY_DATE).getTime() + FIFTEEN_MIN_IN_MILLI_SECS,
    );
  };

  useEffect(() => {
    setAbortController(new AbortController());
    if (searchParams) {
      const currentParams = Object.fromEntries([...searchParams]);
      setSearchRequest(currentParams);
      const searchObj = {
        origin: '',
        destination: '',
        onwarddate: getNewDate(TODAY_DATE),
        returndate: '',
        numadults: '1',
        numchildren: '0',
        numinfants: '0',
        journeytype: 'OneWay',
        prefclass: 'Y',
        requestformat: 'JSON',
        resultformat: 'JSON',
        searchtype: 'normal',
        sortkey: '',
        issbt: 'false',
        profileid: '',
        numresults: 100,
        actionname: 'FLIGHTSEARCH',
        preddeptimewindow: null,
        prefarrtimewindow: null,
        prefcarrier: '',
        excludecarriers: '',
        refundtype: 'All',
        layovertime: '',
        promocode: '',
      };
      const mergedSearchObj = { ...searchObj, ...currentParams };
      resetSearchResults();
      sectorInfoRef.current = `${currentParams.origin}-${currentParams.destination}`;
      if (mergedSearchObj.nonstopsearch === 'true') {
        setSelectedFilters((prev) => ({
          ...prev,
          selectedStops: ['0'],
        }));
      }
      const controller = abortController;
      const { signal } = controller;
      getFlightSearchResults(mergedSearchObj, signal);
    }
    return () => {
      if (abortController) {
        abortController.abort(); // Clean up controller on component unmount or query change
      }
    };
  }, [searchParams]);

  useEffect(() => {
    if (allSearchResultsRef.current.length > 0) {
      handleApplyFilter(selectedFilters);
    }
  }, [allSearchResultsRef.current]);

  const navigateToBookingPage = (rePriceResponse) => {
    const flights = {
      onward:
        rePriceResponse.flightjourneys[0].flightoptions[0].recommendedflight[0],
      return:
        rePriceResponse.flightjourneys[0].flightoptions[0].recommendedflight[1],
    };
    const fares = {
      onward:
        rePriceResponse.flightjourneys[0].flightoptions[0].recommendedflight[0]
          .flightfare,
    };
    const fareKeys = {
      onward: selectedOnwardFareRef.current.nextraflightkey,
    };
    navigate(NAVIGATION_ROUTES.FLIGHT.FLIGHT_BOOK_ROUTE, {
      state: {
        searchRequest,
        rePriceResponse,
        selectedFlight: flights,
        selectedFare: fares,
        selectedFareKeys: fareKeys,
        passThroughInfo: passThroughResponseRef.current,
        journeyType: 'roundtrip',
        domInt: 'international',
      },
    });
  };

  const continueBooking = async () => {
    setOpenAlerDialog(false);
    try {
      setIsLoading(true);
      const userProifle = getObjectFromLS(APP_USER_PROFILE);
      const response = await validateInternationalFlightPriceApi(
        userProifle.agentId,
        searchRequest.journeytype.toLowerCase(),
        selectedOnwardFareRef.current.nextraflightkey,
      );

      if (response && response.NextraPricingResponseV4?.statuscode === '200') {
        const res = await getPassThroughInfo(
          'international',
          response.NextraPricingResponseV4.bookingkey,
        );
        if (res && res.ApiStatus && res.ApiStatus.Status === 'OK') {
          const { PassthroughBookingObject } = res.ApiStatus.Result;
          if (PassthroughBookingObject) {
            passThroughResponseRef.current = PassthroughBookingObject;
          }
        }
        const oldAmounttest = Number(
          response.NextraPricingResponseV4.oldamount,
        );
        const newAmounttest = Number(
          response.NextraPricingResponseV4.newamount,
        );
        if (response.NextraPricingResponseV4.pricechanged) {
          bookingResponseRef.current = response.NextraPricingResponseV4;
          setnewRepricedAmount(response.NextraPricingResponseV4.newamount);
          setOldAmount(response.NextraPricingResponseV4.oldamount);
          if (oldAmounttest !== newAmounttest) {
            setShowPriceChangedModal(true);
          }
          console.log(
            'pricechanged:',
            response.NextraPricingResponseV4.pricechanged,
            typeof response.NextraPricingResponseV4.pricechanged,
          );
        } else {
          navigateToBookingPage(response.NextraPricingResponseV4);
        }
      } else if (
        response &&
        response.ApiStatus &&
        response.ApiStatus.Status === 'NOK'
      ) {
        setAlert({
          title: formattedMessage('booking_error'),
          description: response?.ApiStatus?.Message,
          variant: 'error',
        });
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };

  const handleBook = async () => {
    try {
      const searchRequestOnwardOrigin = searchRequest.origin;
      const searchRequestOnwardDestination = searchRequest.destination;
      const selectedFlightOnwardOrigin =
        selectedOnwardFlightRef.current.flightlegs[0].origin;
      const selectedFlightOnwardDestination =
        selectedOnwardFlightRef.current.flightlegs[
          selectedOnwardFlightRef.current.flightlegs.length - 1
        ].destination;
      const searchRequestReturnOrigin = searchRequest.destination;
      const searchRequestReturnDestination = searchRequest.origin;
      const selectedFlightReturnOrigin =
        selectedReturnFlightRef.current.flightlegs[0].origin;
      const selectedFlightRetuenDestination =
        selectedReturnFlightRef.current.flightlegs[
          selectedReturnFlightRef.current.flightlegs.length - 1
        ].destination;

      if (
        searchRequestOnwardOrigin !== selectedFlightOnwardOrigin ||
        searchRequestOnwardDestination !== selectedFlightOnwardDestination
      ) {
        alertMessageRef.current = `You Onward Searched flights from ${searchRequestOnwardOrigin} to ${searchRequestOnwardDestination} but booking from ${selectedFlightOnwardOrigin} to ${selectedFlightOnwardDestination}. Do you want to continue with it?`;
        setOpenAlerDialog(true);
      } else if (
        searchRequestReturnOrigin !== selectedFlightReturnOrigin ||
        searchRequestReturnDestination !== selectedFlightRetuenDestination
      ) {
        alertMessageRef.current = `You Return Searched flights from ${searchRequestReturnOrigin} to ${searchRequestReturnDestination} but booking from ${selectedFlightReturnOrigin} to ${selectedFlightRetuenDestination}. Do you want to continue with it?`;
        setOpenAlerDialog(true);
      } else {
        continueBooking();
      }
    } catch (error) {
      //
    }
  };
  const handleOnwardFareSelection = (onwardFlight, returnFlight, fare) => {
    selectedOnwardFareRef.current = fare;
    selectedOnwardFlightRef.current = onwardFlight;
    selectedReturnFlightRef.current = returnFlight;
    handleBook();
  };

  const handlePriceChangedModalClose = (isContinue) => {
    if (isContinue) {
      navigateToBookingPage(bookingResponseRef.current);
    }
    setShowPriceChangedModal(false);
  };

  const handlePrevDay = () => {
    if (searchRequest && searchRequest.onwarddate) {
      const request = { ...searchRequest };
      const todayDate = getNewDate(TODAY_DATE);
      const date = sub(getNewDate(searchRequest.onwarddate), { days: 1 });
      if (isBeforeDate(todayDate, date) || isSameDate(todayDate, date)) {
        request.onwarddate = formatDate(getNewDate(date), API_DATE_FORMAT);
        resetSearchResults();
        let queryParam = `origin=${searchRequest.origin}&originLocation=${searchRequest.originLocation}&destination=${searchRequest.destination}&destinationLocation=${searchRequest.destinationLocation}&onwarddate=${request.onwarddate}&returndate=${searchRequest.returndate}`;
        queryParam += `&numadults=${searchRequest.numadults}&numchildren=${searchRequest.numchildren}&numinfants=${searchRequest.numinfants}&prefclass=${searchRequest.prefclass}&journeytype=${searchRequest.journeytype}&preddeptimewindow=&searchtype=${searchRequest.searchtype}&promocode=${searchRequest.promocode}`;
        navigate(
          `${NAVIGATION_ROUTES.FLIGHT.INTERNATIONAL_ROUND_TRIP_FLIGHT_RESULTS_ROUTE}?${queryParam}`,
        );
      } else {
        setAlert({
          variant: 'error',
          title: 'Flight Search',
          description: 'Cannot search for Yesterday',
        });
      }
    }
  };
  const handleNextDay = () => {
    if (searchRequest && searchRequest.returndate) {
      const request = { ...searchRequest };
      const date = add(getNewDate(searchRequest.c), { days: 1 });
      request.returndate = formatDate(getNewDate(date), API_DATE_FORMAT);
      resetSearchResults();
      let queryParam = `origin=${searchRequest.origin}&originLocation=${searchRequest.originLocation}&destination=${searchRequest.destination}&destinationLocation=${searchRequest.destinationLocation}&onwarddate=${searchRequest.onwarddate}&returndate=${request.returndate}`;
      queryParam += `&numadults=${searchRequest.numadults}&numchildren=${searchRequest.numchildren}&numinfants=${searchRequest.numinfants}&prefclass=${searchRequest.prefclass}&journeytype=${searchRequest.journeytype}&preddeptimewindow=&searchtype=${searchRequest.searchtype}&promocode=${searchRequest.promocode}`;
      navigate(
        `${NAVIGATION_ROUTES.FLIGHT.INTERNATIONAL_ROUND_TRIP_FLIGHT_RESULTS_ROUTE}?${queryParam}`,
      );
    }
  };

  const handleFlightSelectionForEmail = (onwardFlight, returnFlight, fare) => {
    setSelectedForEmail((prev) => {
      if (
        prev.some(
          (selectedItem) =>
            selectedItem.fare.nextraflightkey === fare.nextraflightkey,
        )
      ) {
        return prev.filter(
          (selectedItem) =>
            selectedItem.fare.nextraflightkey !== fare.nextraflightkey,
        );
      }
      return [...prev, { onwardFlight, returnFlight, fare }];
    });
  };
  const handleopenWhatsappModal = () => {
    if (selectedForEmail.length > 0) {
      setOpenWhatsappModal(true);
    } else {
      setAlert({
        title: 'WhatsApp flight options',
        description: 'Select atleast one fare',
        variant: 'error',
      });
    }
  };

  const handleOpenEmailModal = () => {
    if (selectedForEmail.length > 0) {
      setOpenEmailModal(true);
    } else {
      setAlert({
        title: 'Email flight options',
        description: 'Select atleast one fare',
        variant: 'error',
      });
    }
  };

  const handleSendWhatsappMessage = (whatsappNumber, msg) => {
    setIsLoading(true);
    const encodedMessage = encodeURIComponent(msg);
    const whatsAppUrl = `https://api.whatsapp.com/send?phone=${whatsappNumber}&text=${encodedMessage}`;
    window.open(whatsAppUrl);
    setOpenWhatsappModal(false);
    setSelectedForEmail([]);
    setIsLoading(false);
  };

  const handleSendEmailMessage = async (senderEmail, emailContent) => {
    setIsLoading(true);
    let fromEmail = '';
    let fromName = '';
    const res = await getUserDetails(agentid);
    if (res.ApiStatus?.Status === 'OK') {
      const { User } = res.ApiStatus.Result;
      fromEmail = User.ContactEmail;
      fromName = `${User.FirstName} ${User.LastName}`;
    }
    if (fromEmail !== '') {
      const emailSub = `Your flight booking details for ${
        searchRequest.originLocation.split(',')[0]
      } - 
      ${searchRequest.destinationLocation.split(',')[0]} ${formatDate(
        getNewDate(searchRequest.onwarddate),
        API_DATE_FORMAT,
      )} | ${formatDate(
        getNewDate(searchRequest.returndate),
        API_DATE_FORMAT,
      )}`;
      const response = await emailFlightOptions(
        fromEmail,
        fromName,
        senderEmail,
        emailContent,
        emailSub,
      );
      if (response && response?.Root?.Status === 'OK') {
        setAlert({
          title: formattedMessage('email_btn'),
          description: formattedMessage('email_sent_successfully'),
          variant: 'success',
        });
        setOpenEmailModal(false);
        setIsLoading(false);
      } else {
        setAlert({
          title: formattedMessage('email_btn'),
          description: response?.Root?.Message
            ? response?.Root?.Message
            : formattedMessage('failed_send_email'),
          variant: 'error ',
        });
        setOpenEmailModal(false);
        setIsLoading(false);
      }
    } else {
      setAlert({
        title: formattedMessage('user_Details'),
        description: res.ApiStatus?.Message
          ? res.ApiStatus?.Message
          : formattedMessage('failed_toload_agent_Details'),
        variant: 'error ',
      });
      setOpenEmailModal(false);
      setIsLoading(false);
    }
    setSelectedForEmail([]);
  };

  const handleTimeFormatChange = (isAmPmFormat) => {
    setIsAmPmFormatSelected(isAmPmFormat);
  };

  const handleDirectNavigateToBookingPage = async (key, rePriceResponse) => {
    setIsLoading(true);
    const domint = 'international';
    const res = await getPassThroughInfo(domint, rePriceResponse.bookingkey);
    if (res && res.ApiStatus && res.ApiStatus.Status === 'OK') {
      const { PassthroughBookingObject } = res.ApiStatus.Result;
      if (PassthroughBookingObject) {
        passThroughResponseRef.current = PassthroughBookingObject;
      }
    }
    const flight = {
      onward:
        rePriceResponse.flightjourneys[0].flightoptions[0].recommendedflight[0],
      return:
        rePriceResponse.flightjourneys[0].flightoptions[0].recommendedflight[1],
    };
    const fare = {
      onward:
        rePriceResponse.flightjourneys[0].flightoptions[0].recommendedflight[0]
          .flightfare,
    };
    const fareKeys = {
      onward: key,
    };
    navigate(NAVIGATION_ROUTES.FLIGHT.FLIGHT_BOOK_ROUTE, {
      state: {
        searchRequest,
        rePriceResponse,
        selectedFlight: flight,
        selectedFare: fare,
        selectedFareKeys: fareKeys,
        passThroughInfo: passThroughResponseRef.current,
        journeyType: 'roundtrip',
        domInt: 'international',
      },
    });
  };

  const handleFareInclusionIntl = async () => {
    const response = await getFareInclusionINTL();
    if (
      response &&
      response.Root &&
      response.Root.Status === 'OK' &&
      response.Root.StatusCode === 200
    ) {
      const fareInclusionsMap = {};
      let fareInclusions = response.Root.Result.FareInclusions.FareInclusion;
      fareInclusions = Array.isArray(fareInclusions)
        ? fareInclusions
        : [fareInclusions];
      fareInclusions.forEach((incl, index) => {
        if (fareInclusionsMap[incl.FareType]) {
          fareInclusionsMap[incl.FareType] = incl;
        } else {
          fareInclusionsMap[incl.FareType] = incl;
        }
      });
      fareInclusionRef.current = fareInclusionsMap;
    }
  };

  useEffect(() => {
    handleFareInclusionIntl();
  }, []);

  return (
    <>
      <section className="flight-round-trip-intl-search-results-page">
        {showProgressRef.current && (
          <div className="flight-progress-container">
            <ProgressBar striped variant="info" now={progressWidth} />
          </div>
        )}
        <AppLoading isLoading={isLoading} />
        {alert && (
          <AppAlert
            showIcon
            variant={alert.variant}
            title={alert.title}
            onHide={() => setAlert(undefined)}
            description={alert.description}
          />
        )}
        <div className="countdown-timer-container visually-hidden">
          <CountdownTimer
            targetDate={fifteenMinFromNowInMilli}
            continueBtnText={formattedMessage('continue_btn')}
            continueRoutePath={formattedMessage('refresh_btn')}
          />
        </div>
        {searchRequest && (
          <>
            {isMobileWidth() ? (
              <div className="modify-search-container">
                <div className="d-flex">
                  <AppIconButton
                    onClick={() => navigate(-1)}
                    className="white-color"
                    variant="transparent"
                  >
                    <MdOutlineArrowBack />
                  </AppIconButton>
                  <div className="d-flex justify-content-between p-2 align-items-center flex-1">
                    <div className="fs-14 white-color">
                      <div>
                        {searchRequest.originLocation.split(',')[0]} to{' '}
                        {searchRequest.destinationLocation.split(',')[0]}
                      </div>
                      <div className="fs-10">
                        <span>{searchRequest.journeytype} | </span>
                        {formatDate(
                          getNewDate(searchRequest.onwarddate),
                          DATE_MONTH_YEAR_VIEW_FORMAT,
                        )}{' '}
                        |{' '}
                        {formatDate(
                          getNewDate(searchRequest.returndate),
                          DATE_MONTH_YEAR_VIEW_FORMAT,
                        )}
                      </div>
                    </div>
                    <div className="d-flex  align-items-center">
                      {isModifySearch ? (
                        <AppIconButton
                          className="white-color"
                          variant="transparent"
                          onClick={() => setIsModifySearch(false)}
                        >
                          <MdClose className="fs-4" />
                        </AppIconButton>
                      ) : (
                        <AppIconButton
                          className="white-color"
                          variant="transparent"
                          onClick={() => setIsModifySearch(true)}
                        >
                          <MdOutlineCreate className="fs-4" />
                        </AppIconButton>
                      )}
                      <AppIconButton
                        className="white-color"
                        variant="transparent"
                        onClick={() => setOpenFilters(true)}
                      >
                        <MdOutlineFilterAlt className="fs-4" />
                      </AppIconButton>
                    </div>
                  </div>
                </div>
                {isModifySearch && (
                  <div className="slide-container">
                    <ModifySearch
                      isModifySearch={isModifySearch}
                      previousSearchRequest={searchRequest}
                    />
                  </div>
                )}
              </div>
            ) : (
              <section
                className="modify-search-container hide-for-599px"
                ref={flightModifyRef}
              >
                <ModifySearch previousSearchRequest={searchRequest} />
              </section>
            )}

            {progressWidth < 100 &&
              allSearchResultsRef.current.length === 0 && <AppPreviewLoader />}
            {hasSearchResults ? (
              <section className="flight-app-container pt-0 ">
                <Row className="spacing-8">
                  {!isMobileWidth() && (
                    <Col
                      lg={3}
                      className=" display-md-none p-0 "
                      style={{ top: `${flightModifyDivHeight + 70}px` }}
                    >
                      <RoundTripFilters
                        minPrice={minFlightFare}
                        maxPrice={maxFlightFare}
                        carriers={flightCarriesRef.current}
                        fareTypes={flightFaresRef.current}
                        selectedFilters={selectedFilters}
                        onApplyFilter={handleApplyFilter}
                        onTimeFormatChange={handleTimeFormatChange}
                        sectorInfo={sectorInfoRef.current}
                      />
                    </Col>
                  )}
                  <Col
                    lg={9}
                    className=" ps-sm-2 margin-for-hotel-results-card"
                  >
                    {isMobileWidth() ? (
                      <SortOptions
                        onSort={(param, order, isOnwardR) =>
                          handleSort(param, order)
                        }
                        isOnward
                        prevSortParam={sortParamRef.current}
                      />
                    ) : (
                      <div>
                        <div className="fs-5 fw-500 d-flex justify-content-between">
                          <span>
                            Flights From{' '}
                            {searchRequest.originLocation.split(',')[0]} -{' '}
                            {searchRequest.destinationLocation.split(',')[0]}
                          </span>
                          <div>
                            <AppIconButton
                              variant="transparent"
                              className="fs-14"
                              onClick={handleopenWhatsappModal}
                            >
                              <MdOutlineWhatsapp title="WhatsApp" />
                            </AppIconButton>
                            <AppIconButton
                              variant="transparent"
                              className="fs-14"
                              onClick={handleOpenEmailModal}
                            >
                              <MdOutlineMail title="Email" />
                            </AppIconButton>
                            <AppIconButton
                              variant="transparent"
                              className="fs-14"
                              onClick={() =>
                                setShowInvoiceFare((prev) => !prev)
                              }
                            >
                              {showInvoiceFare ? (
                                <IoMdEyeOff title="Net Fare" />
                              ) : (
                                <IoMdEye title="Net Fare" />
                              )}
                            </AppIconButton>
                          </div>
                        </div>
                        <div className="my-1">
                          <div className="flight-sort-options d-flex">
                            <div
                              className={`sort-btn ${
                                sortParamRef.current === 'price'
                                  ? 'selected-sort-btn'
                                  : ''
                              }`}
                              onClick={() => handleSort('price', 'asc')}
                            >
                              Cheapest Flights
                            </div>
                            <div
                              className={`sort-btn border-inline ${
                                sortParamRef.current === 'duration'
                                  ? 'selected-sort-btn'
                                  : ''
                              }`}
                              onClick={() => handleSort('duration', 'asc')}
                            >
                              Shortest Duration
                            </div>
                            <div
                              className={`sort-btn ${
                                sortParamRef.current === 'departure'
                                  ? 'selected-sort-btn'
                                  : ''
                              }`}
                              onClick={() => handleSort('departure', 'asc')}
                            >
                              Early Depart
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    <section>
                      {shownResults.map((row, index) => (
                        <RoundTripIntlResultCard
                          key={row.recommendedflight[0].nextraflightkey}
                          onwardFlight={row.recommendedflight[0]}
                          returnFlight={row.recommendedflight[1]}
                          onwardFares={
                            Array.isArray(row.recommendedflight[0].flightfare)
                              ? row.recommendedflight[0].flightfare
                              : [row.recommendedflight[0].flightfare]
                          }
                          selectedFare={selectedOnwardFareRef.current}
                          onFareSelection={handleOnwardFareSelection}
                          onSelectForEmail={handleFlightSelectionForEmail}
                          flightsForEmail={selectedForEmail}
                          showInvoiceFare={showInvoiceFare}
                          searchRequest={searchRequest}
                          isAmPmFormat={isAmPmFormatSelected}
                          index={index}
                          onNavigateToBookingPage={
                            handleDirectNavigateToBookingPage
                          }
                          onShareViaEmail={handleOpenEmailModal}
                          onShareViaWhatsapp={handleopenWhatsappModal}
                          fareInclusions={fareInclusionRef.current}
                        />
                      ))}
                      {searchResults.length === 0 &&
                        hasSearchResults === true && (
                          <NoSearchResults
                            message={formattedMessage(
                              'no_search_results_message_1',
                            )}
                          />
                        )}
                    </section>
                  </Col>
                </Row>
              </section>
            ) : (
              allSearchResultsRef.current.length === 0 &&
              progressWidth === 100 && <NoSearchResults />
            )}
          </>
        )}
        {openFilters && (
          <AppSidebar
            sidebarTitle={formattedMessage('filters')}
            showActions
            onHideSidebar={() => setOpenFilters(false)}
          >
            <RoundTripFilters
              minPrice={minFlightFare}
              maxPrice={maxFlightFare}
              carriers={flightCarriesRef.current}
              fareTypes={flightFaresRef.current}
              selectedFilters={selectedFilters}
              onApplyFilter={handleApplyFilter}
              onTimeFormatChange={handleTimeFormatChange}
              sectorInfo={sectorInfoRef.current}
            />
          </AppSidebar>
        )}
        {showPriceChangedModal && (
          <AppModal
            modalTitle="Fare Change Alert"
            showCloseButton={false}
            okText="Continue"
            cancelText="Select Another Flight"
            showFooter
            onModalClose={handlePriceChangedModalClose}
          >
            <div className="d-flex flex-column align-items-center red-color fs-3">
              <BsGraphUpArrow />
              <span>Ooops!</span>
            </div>
            <p className="fs-14 mb-0 text-center mt-2">
              The Airline has increased the fare on this route by{' '}
              {formatCurrency(newRepricedAmount - oldAmount)}
            </p>
            <p className="fs-14 mb-0 text-center">
              Please note that airfares e dynamicnd subject to change.
            </p>
            <p className="fs-14 mb-0 text-center">
              Select from the options below
            </p>
            <div className="d-flex flex-column align-items-center fw-600 fs-14 mt-3">
              <span>
                UPDATED FARE{'      '} {formatCurrency(newRepricedAmount)}
              </span>
              <span>
                ORIGINAL FARE{'      '} {formatCurrency(oldAmount)}
              </span>
              <span>
                DIFFERENCE FARE{'      '}{' '}
                {formatCurrency(newRepricedAmount - oldAmount)}
              </span>
            </div>
          </AppModal>
        )}
        {openWhatsappModal && (
          <AppModal
            modalTitle="Send WhatsApp"
            showCloseButton
            size="lg"
            onModalClose={() => setOpenWhatsappModal(false)}
          >
            <RoundTripIntlWhatsAppModal
              onSend={handleSendWhatsappMessage}
              selectedFlights={selectedForEmail}
              searchRequest={searchRequest}
            />
          </AppModal>
        )}
        {openEmailModal && (
          <AppModal
            showCloseButton
            onModalClose={() => setOpenEmailModal(false)}
            size="lg"
            modalTitle="Send Email"
          >
            <RoundTripIntlEmailContent
              selectedFlights={selectedForEmail}
              onSend={handleSendEmailMessage}
              searchRequest={searchRequest}
            />
          </AppModal>
        )}
        {OpenAlerDialog && (
          <AppModal
            modalTitle="Are You Sure?"
            showCloseButton
            className="help-support-modal"
            cancelText="Close"
            onModalClose={() => setOpenAlerDialog(false)}
          >
            <div className="fs-16 align-items-center p-4">
              {alertMessageRef.current}
            </div>
            <div className="d-flex justify-content-end gap-3 p-2">
              <AppButton
                btnText="NO, Cancel"
                variant="outlined"
                onClick={() => setOpenAlerDialog(false)}
              />
              <AppButton btnText="Yes, Continue" onClick={continueBooking} />
            </div>
          </AppModal>
        )}
      </section>
    </>
  );
}

export default FlightRoundTripIntlSearchResultsPage;
